import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateMediaItemDocument } from './update.generated';

export const useUpdateMediaItem = (options: ApiOptions<typeof UpdateMediaItemDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateMediaItemDocument, {
    ...useNotifications(UpdateMediaItemDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => {
        const type = data.updateMediaItem?.mediaItem?.__typename;
        return t('api.media_items.update_success', { type });
      },
    }),

    ...options,
  });
};
